import { Loader } from '~/shared/ui'
import { Steerage, useSteerage } from '~/entities/steerage'
import { SteerageView } from './SteerageView'

type SteerageRelatedModel = Pick<Steerage, 'id'> & { active_case_id?: number | null }

const SteerageRelatedView = ({ model }: { model: SteerageRelatedModel }) => {
  return <SteerageEditor id={model.id} activeCaseId={model.active_case_id ?? null} />
}
// Helper for fetching the full Steerage prior to rendering the edit form.
const SteerageEditor: React.FC<{
  id: Steerage['id']
  activeCaseId: number | null
}> = ({ id, activeCaseId }) => {
  const { data: steerage, isPending: isLoading } = useSteerage(id)

  if (isLoading || !steerage) {
    return <Loader inline={true} />
  }

  return <SteerageView steerageId={id} activeCaseId={activeCaseId} />
}
export default SteerageRelatedView
